export default __webpack_public_path__ + "static/media/nov2023-5.f4c65a2a.jpg";